export default __webpack_public_path__ + "static/media/coib-nou-logo-blanc.72f3d956.png";